export enum AssetCondition {
  Unknown = 0,
  Poor = 1,
  Fair = 2,
  Good = 3,
  VeryGood = 4,
  Excellent = 5
}

export const AssetConditionMapping: Record<AssetCondition, string> = {
  [AssetCondition.Unknown]: 'Unknown',
  [AssetCondition.Poor]: 'Poor',
  [AssetCondition.Fair]: 'Fair',
  [AssetCondition.Good]: 'Good',
  [AssetCondition.VeryGood]: 'Very Good',
  [AssetCondition.Excellent]: 'Excellent'
};
